$(document).ready(function() {
  $(".event-anchor-link").click(function() {
    let id = $(this).attr("id");
    $("." + id).attr("checked", "checked");
    $(".registration-form")[0].scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});  